import React from 'react'
import ffffff from '../image/ffffff.avif'
import { styled } from '@mui/system';
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import Typography from '@mui/material/Typography';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
const useStyles = styled((theme) => ({
  root: {
    width: '100%',
  },
  heading: {
    fontSize: theme.typography.pxToRem(15),
    flexBasis: '33.33%',
    flexShrink: 0,
  },
  secondaryHeading: {
    fontSize: theme.typography.pxToRem(15),
    color: theme.palette.text.secondary,
  },
}));


function Video_FAQ_page() {
  return (
    <div>
    <div className='mt-5'>
      <div className='container pt-3'>
      <div className='text-center Curriculum_Main_text'>
      <div className=''>
        <h2 className='display-6'>Frequently Asked Questions</h2>
        <p className='pt-2'>Our Responses to Your Inquiries: Unblocking the Way to Clarity</p>
      </div>
      </div>
        <div className='row'>
        <div className='col-md-5'>
            <div className='FAQ_img'>
            <img src={ffffff} onContextMenu={(e) => e.preventDefault()}></img>
            </div>
        </div>
        <div className='col-md-7 pt-5 d-none d-md-block'>
          <div className='pt-5'>
          <div className='pt-5'>
            <div className='pt-5'>
            <Video_FAQ/>
            </div>
          </div>
          </div>
        </div>
        <div className='col-md-12 d-sm-block d-md-none mb-5'>
        <Video_FAQ/>
        </div>
        </div>
      </div>
    </div>
    </div>
  )
}

function Video_FAQ(){
  const classes = useStyles();
  const [expanded, setExpanded] = React.useState(false);

  const handleChange = (panel) => (event, isExpanded) => {
    setExpanded(isExpanded ? panel : false);
  };

  return (
    <div className={classes.root}>
      <Accordion className='py-2' expanded={expanded === 'panel1'} onChange={handleChange('panel1')}>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel1bh-content"
          id="panel1bh-header" className='FAQ_background_color'
        >
          <Typography style={{fontSize:"1.2rem"}}>Why do we need Artificial Intelligence?</Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography>
          The goal of Artificial intelligence is to create intelligent machines that can mimic human behavior. We need AI for today’s world to solve complex problems, make our lives more smoothly by automating the routine work, saving the manpower, and to perform many more other tasks.
          </Typography>
        </AccordionDetails>
      </Accordion>
      <Accordion className='py-2' expanded={expanded === 'panel2'} onChange={handleChange('panel2')}>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel2bh-content"
          id="panel2bh-header"
          className='FAQ_background_color'
        >
          <Typography style={{fontSize:"1.2rem"}}>What do you understand by Artificial Intelligence?</Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography>
          Artificial intelligence is computer science technology that emphasizes creating intelligent machine that can mimic human behavior. Here Intelligent machines can be defined as the machine that can behave like a human, think like a human, and also capable of decision making. It is made up of two words, “Artificial” and “Intelligence,” which means the “man-made thinking ability.”
          </Typography>
        </AccordionDetails>
      </Accordion>
      <Accordion className='py-2' expanded={expanded === 'panel3'} onChange={handleChange('panel3')}>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel3bh-content"
          id="panel3bh-header"
          className='FAQ_background_color'
        >
          <Typography style={{fontSize:"1.2rem"}}>What is Deep Learning, and how is it used in real-world?</Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography>
          Deep learning is a subset of Machine learning that mimics the working of the human brain. It is inspired by the human brain cells, called neurons, and works on the concept of neural networks to solve complex real-world problems. It is also known as the deep neural network or deep neural learning.
          </Typography>
        </AccordionDetails>
      </Accordion>
    </div>
  );
}

export default Video_FAQ_page
